import React from 'react';

import CloseRoundedIcon from "../../../assets/icons/calendar/close-rounded.svg?react";
import WarningIcon from "../../../assets/icons/calendar/warning.svg?react";
import CheckSuccessIcon from "../../../assets/icons/calendar/round-check.svg?react";
import CloseIcon from "../../../assets/icons/close-modal.svg?react";
import './BannerStatusMessage.scss';

const BannerStatusMessage = ({ type = 'success', showBanner = false, message, onClose }) => {
	const getBannerClass = () => {
		switch (type) {
			case 'error':
				return 'banner-status-message error';
			case 'warning':
				return 'banner-status-message warning';
			case 'success':
			default:
				return 'banner-status-message success';
		}
	};

    const getIcon = () => {
		switch (type) {
			case 'error':
				return <CloseRoundedIcon className="icon close-rounded-icon" />
			case 'warning':
				return <WarningIcon className="icon warning-icon" />
			case 'success':
			default:
				return <CheckSuccessIcon className="icon success-icon" />
		}
	};

	return (
		showBanner && (
			<div className={`${getBannerClass()} mt-4`} role="alert">
				<div className='ml-3'>
					{getIcon()}
					<span className="ml-2">{message}</span>
				</div>
				{onClose && (
					<CloseIcon className="cursor-pointer" onClick={onClose} />
				)}
			</div>
		)
	);
};

export default BannerStatusMessage;
